import { createContext } from 'react';

export const BreakpointContext = createContext('sm');

export const BreakpointProvider = BreakpointContext.Provider;
export const BreakpointConsumer = BreakpointContext.Consumer;
